import React from 'react';
import styles from './pm.module.css';

const PromotionMessages = ({ onProfileClick }) => {
    const profiles = [
        { id: 1, name: 'Profile 1' },
        { id: 2, name: 'Profile 2' },
        { id: 3, name: 'Profile 3' },
        { id: 4, name: 'Profile 4' },
        // Add more profiles as needed
    ];

    return (
        <div className={styles.container}>
            <div className={styles.pm}>
            <h3>Promotion Messages</h3>
            <ul >
                {profiles.map(profile => (
                    <li key={profile.id} onClick={() => onProfileClick(profile)}>
                        {profile.name}
                    </li>
                ))}
            </ul>
            </div>
        </div>
    );
};

export default PromotionMessages;